import { theme } from '@maersktankersdigital/web-components'
import { TextField, TextFieldProps } from '@mui/material'
import { useEffect, useRef } from 'react'
import { COLORS } from '~theme/colors'

interface TextareaProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value: string | number | undefined
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
  disableInitialFocus?: boolean
  type?: string
}

export function Textarea({
  value,
  onChange,
  sx,
  disableInitialFocus,
  type,
  ...rest
}: TextareaProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current && !disableInitialFocus) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <TextField
      error={type === 'number' && !!value && isNaN(Number(value))}
      helperText={
        type === 'number' && !!value && isNaN(Number(value))
          ? 'Entry must be a number and use dot (.) as decimal separator'
          : ''
      }
      value={value}
      onChange={onChange}
      inputRef={inputRef}
      sx={{
        fontFamily: theme.FONTS.families.regular,
        width: '100%',
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: `${COLORS.secondary.darkBlue}`,
          },
          '&:hover': {
            backgroundColor: `${COLORS.secondary.blueTint}`,
            '& fieldset': {
              borderColor: `${COLORS.primary.maerskBlue}`,
            },
            '& textarea': {
              backgroundColor: `${COLORS.secondary.blueTint}`,
            },
          },
          '&.Mui-focused fieldset': {
            borderColor: `${COLORS.primary.maerskBlue}`,
          },
        },
        ...sx,
      }}
      placeholder="There is no data yet."
      maxRows={Infinity}
      {...rest}
    />
  )
}
